module.exports = __webpack_public_path__ + "img/rayz-profile.fbb9d28.jpg";